import Loading from './src/Loading'

Loading.install = function(Vue) {
  Vue.component(Loading.name, Loading); 
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/index.js